import React from 'react';
import src from '../../Assets/loader.png';
import '../Loader/loader.css'

const Loader = () => {
  return (
      <img src={src} alt="image" className="rotating-image" />
  );
};

export default Loader;